module.exports = {
  title: "Skákgreind",
  learn: "Læra",
  teach: "Kenna",
  about: "Um okkur",
  helpUs: "Hjálpa",
  signUp: "Skráðu þig",
  methods: "Tækni",
  software: "Hugbúnaður",
  signIn: "Ská inn",

  "subscribe.label": "Skrá á póstlista",
  "subscribe.button": "Skrá",

  introVideo: "Kynningar Myndband",
  close: "Loka",

  cancel: "Hætta við",

  email: "Netfang",
  phone: "Símanúmer",
  firstname: "Nafn",
  lastname: "Eftirnafn",
  name: "Nafn",
  message: "Skilaboð",
  send: "Senda",
  subject: "Erindi",
  seeFaqs: "Áður að þú sendir okkur skilaboð vinsæmlega skoða",
  username: "Notendanafn",
  password: "Lykilorð",
  confirmPassword: "Staðfesta lykilorð",
  birthYear: "Fæðingarár",
  gender: "Kyn",
  recommendedBy: "Mælt með af",
  skillLevel: "Reynsla af skák",
  elo: "ELO stig",
  country: "Þjóð",
  school: "Skóli",
  whyMessage: "Þjálfunar markmið þín með SciChess?",
  selectBYear: "Velja fæðingarár",
  selectGender: "Velja kyn...",
  selectSkill: "Velja reynsla...",
  selectCountry: "Velja þjóð...",
  optional: "valfrjálst",
  city: "Borg",
  male: "Karlkyns",
  female: "Kvenkyns",
  other: "Annað",
  beginner: "Bryjandi",
  intermediate: "Millistig",
  expert: "Sérfræðingur",

  continue: "Halda áfram",
  previous: "Til baka",

  sendingSubscription: "Skráning í gangi...",
  successSubscription: "tókst í skráning!",
  failedSubscription: "Er nú þegar áskrifandi að póstlista okkar!",
  missingSubscription: "Vantar upplýsingar, vinsamlega fyllið inn allar reiti",

  donors: "Hollvinir",
  partners: "Samstarfsaðilar",
  contactUs: "Hafa samband",
  faqs: "Algengar spurningar",
  studies: "Rannsóknir",
  ourTeam: "Teymið okkar",
  newsroom: "Fréttir",

  hedinn: "Héðinn Steingrímsson",
  grandmaster: "Stórmeistari",

  joinUs: "Ganga til liðs við okkur",
  stayTuned: "Fylgist með",

  downloadOcuchess: "Hlaða niður OcuChess",
  downloadOcuchessLine2: "Okkar háþróaðsta þjálfunarforriti"

};



// WEBPACK FOOTER //
// ./src/data/messages/is.js